import { useLang } from '../i18n/LanguageContext'
import './FeaturesPage.css'

// In the order of features.screens in the locale files.
const SCREENS = ['admin-dashboard', 'admin-bookings', 'public-calendar', 'admin-event', 'public-seatmap', 'admin-seatmap', 'admin-memberships', 'admin-invoices', 'public-mobile']

function FeaturesPage() {
  const { t } = useLang()
  const features = t('features.list')
  const screens = t('features.screens')

  return (
    <div className="features-page">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <h1 className="hero-title" style={{textAlign: 'center'}}>
            {t('features.heroTitle')}
          </h1>
          <p className="hero-subtitle" style={{textAlign: 'center', maxWidth: '600px', margin: '0 auto'}}>
            {t('features.heroSubtitle')}
          </p>
        </div>
      </section>

      {/* Features Grid - Compact */}
      <section className="section">
        <div className="container">
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-card">
                <div className="feature-header">
                  <span className="feature-icon">{feature.icon}</span>
                  <h3 className="feature-title">{feature.title}</h3>
                </div>
                <p className="feature-desc">{feature.description}</p>
                <ul className="feature-list">
                  {feature.details.map((detail, dIndex) => (
                    <li key={dIndex}>
                      <span className="check">✓</span>
                      {detail}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* The product as it looks: screenshots from the demo foreningen */}
      <section className="section" style={{background: 'var(--bg-alt)'}}>
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">{t('features.screensTitle')}</h2>
            <p className="section-subtitle">{t('features.screensSubtitle')}</p>
          </div>
          <div className="screens-grid">
            {SCREENS.map((file, index) => (
              <figure key={file} className={`screen-card ${file === 'public-mobile' ? 'screen-card--phone' : ''}`}>
                <img
                  src={`/screens/${file}.png`}
                  alt={`${screens[index].title}: ${screens[index].text}`}
                  loading="lazy"
                  width={file === 'public-mobile' ? 391 : 1440}
                  height={file === 'public-mobile' ? 844 : 900}
                />
                <figcaption>
                  <strong>{screens[index].title}</strong>
                  <span>{screens[index].text}</span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta">
        <div className="container">
          <h2 className="cta-title">{t('features.ctaTitle')}</h2>
          <p className="cta-text">{t('features.ctaText')}</p>
          <a href="/signup" className="btn btn-white btn-lg">
            {t('features.ctaButton')}
          </a>
        </div>
      </section>
    </div>
  )
}

export default FeaturesPage
